import {Route, Routes} from "react-router";
import React from "react";
import TripCheckList from "./page/list";
import TripCheckEdit from "./page/edit";



export default function() {
  return (
    <Routes>
      <Route path={'list'} element={<TripCheckList/>} />
      <Route path={'edit/:id'} element={<TripCheckEdit/>} />
    </Routes>
  );
}
